"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var ThemeManager_1 = require("./ThemeManager");
exports.StyledThemeProvider = function (props) {
    var children = props.children, darkTheme = props.darkTheme, lightTheme = props.lightTheme;
    var themeManagerContext = react_1.useContext(ThemeManager_1.ThemeManagerContext);
    var isDark = themeManagerContext.isDark;
    var currentTheme = isDark ? darkTheme : lightTheme;
    var theme = __assign(__assign({}, currentTheme), { isDark: isDark });
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(react_1.default.Fragment, null, children)));
};
